import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

interface RowProps {
  className?: string;
  bufferRowReset?: boolean;
  children?: React.ReactNode;
  dataArchived?: boolean;
  dataTestAttrs?: DataTestAttrs;
}

export default function Row(props: RowProps): JSX.Element {
  return (
    <div
      className={classNames('row', props.className, {bufferRowReset: props.bufferRowReset})}
      data-archived={props.dataArchived ? 'true' : undefined}
      {...getTestProps(props.dataTestAttrs)}
    >
      {props.children}
    </div>
  );
}
